// OWL — la fila "acabado" navega a la ficha gemela en vez de transformar la pagina.
// El morph de <main> del tema rompe los refs de la galeria de imagenes (medido:
// ref="media[]" pasa de 3 a 0 en HEAVENLY y de 5 a 2 en TYLER), y con ellos el zoom.
// Diseno: Shopify/pedreria-variantes-2026-08-14/DISENO.md
//
// OWL: data-owl-href queda en el propio <input> (junto a los demas data-* que ya
// tenia esa fila en snippets/owl-acabado-options.liquid), no en el <label>. Se lee
// aqui directamente de event.target por eso.
document.addEventListener(
  'change',
  (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement)) return;
    const href = input.dataset.owlHref;
    if (!href) return;
    event.stopPropagation();
    window.location.assign(href);
  },
  true
);
